import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MainContainer, OutlinedButton, PaperBox, SadFace } from '../.';
import { useEnvironment } from '../contexts';
import React from 'react';
export var CliLoginFailure = function CliLoginFailure() {
    var environment = useEnvironment().environment;
    var backHome = function backHome() {
        window.location.href = environment.dashboardUrl;
    };
    return /*#__PURE__*/ _jsx(MainContainer, {
        children: /*#__PURE__*/ _jsx(PaperBox, {
            footer: /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-between w-full",
                children: /*#__PURE__*/ _jsx(OutlinedButton, {
                    label: "Back to Home page",
                    onClick: backHome
                })
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-row items-center justify-between mt-8 w-full gap-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-row items-center mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx(SadFace, {}),
                                    /*#__PURE__*/ _jsx("h1", {
                                        className: "ml-2 text-[var(--color-primary-error)] text-[32px] font-semibold leading-[38px] tracking-[-0.01562em] m-0",
                                        children: "Something went Wrong"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "font-normal text-sm text-[var(--color-secondary)]",
                                children: "Something unexpected happened while trying to login to the CLI, please try again."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "/vectors/power-plugs-off.svg",
                        alt: "CLI Login Failure Illustration",
                        width: "240",
                        height: "140"
                    })
                ]
            })
        })
    });
};
